import React, {Component} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
} from "react-router-dom";

import '../css/Menu.css';
import PageAvvalimenti from "../../page/js/PageAvvalimenti";
import PageUfficioGareEsterno from "../../page/js/PageUfficioGareEsterno";
import PageConsorzio from "../../page/js/PageConsorzio";
import PageSoaIso from "../../page/js/PageSoaIso";
import PageContatti from "../../page/js/PageContatti";
import PageOffertaTecnica from "../../page/js/PageOffertaTecnica";
import PageHome from "../../page/js/PageHome";

const menuItems = [
    {
        "to": "/",
        "title": "Home"

    },
    {
        "to": "/offerta_tecnica",
        "title": "Offerta Tecnica"
    },
    {
        "to": "/avvalimenti",
        "title": "Avvalimenti"
    },
    {
        "to": "/gare_esterno",
        "title": "Ufficio Gare Esterno"
    },
    {
        "to": "/consorzio",
        "title": "Consorzio"
    },
    {
        "to": "/soa_iso",
        "title": "Consulenza SOA - ISO"
    },
    {
        "to": "/contatti",
        "title": "Contatti"
    },
];


class Menu extends Component {

    render() {
        return (
            <Router>
                <div className="fancyNav">
                    <ul className="menu-ul">
                        {
                            menuItems.map(menuItem =>
                                <li className="menu-li menu-li-mobile">
                                    <NavLink to={menuItem.to} className="inactive" activeClassName="active"
                                             exact={true}>
                                        {menuItem.title}
                                    </NavLink>
                                </li>
                            )
                        }
                    </ul>

                    <Switch>

                        <Route path="/avvalimenti">
                            <PageAvvalimenti />
                        </Route>
                        <Route path="/gare_esterno">
                            <PageUfficioGareEsterno />
                        </Route>
                        <Route path="/consorzio">
                            <PageConsorzio />
                        </Route>
                        <Route path="/soa_iso">
                            <PageSoaIso />
                        </Route>
                        <Route path="/contatti">
                            <PageContatti />
                        </Route>
                        <Route path="/offerta_tecnica">
                            <PageOffertaTecnica />
                        </Route>
                        <Route path="/">
                            <PageHome />
                        </Route>
                    </Switch>
                </div>
            </Router>
        );
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/menu/js/Menu.js